import React from 'react';
import { BaseComponentProps } from '..';
import LogoImage from '../../assets/add-to-apple-wallet-logo.png';

export const AddToAppleWallet = (props: BaseComponentProps): JSX.Element => {
  const { inputs } = props;
  const url = inputs.filter((input) => input.key === 'url')[0].value ?? '';
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <img
        src={LogoImage}
        style={{
          width: '12rem',
          cursor: 'pointer',
        }}
      />
    </a>
  );
};
